const NOTIFICATION = {
  ORIGINS: {
    ARTICLE: 'ARTICLE',
    COUPON: 'COUPON',
    MESSAGE: 'MESSAGE',
    OFFER: 'OFFER',
    THREAD: 'THREAD',
  },
  TYPES: {
    MESSAGE: 'MESSAGE',
    NOTIFICATION: 'NOTIFICATION',
    WISHLIST: 'WISHLIST',
  },
  NEWS: 'Novas',
  OLDER: 'Anteriores',
  MARK_ALL_AS_READ: 'Marcar todas como lidas',
};

export default NOTIFICATION;
